import { cn } from '@/lib/utils';

/* Lead category chips (item 7). Names come from the server projection
 * (category_labels — the workspace list's current names). Purely presentational;
 * wraps on narrow cards, never scrolls the page sideways. */
export function CategoryChips({ names, className, max = 4 }: { names: string[]; className?: string; max?: number }) {
  if (!names.length) return null;
  const shown = names.slice(0, max);
  const more = names.length - shown.length;
  return (
    <div className={cn('flex min-w-0 flex-wrap gap-1', className)} data-testid="category-chips">
      {shown.map((n) => (
        <span key={n} className="max-w-full truncate rounded-full border border-border-subtle bg-inset px-2 py-0.5 text-[11px] leading-4 text-text-secondary">{n}</span>
      ))}
      {more > 0 ? <span className="rounded-full px-1.5 py-0.5 text-[11px] leading-4 text-text-tertiary">+{more}</span> : null}
    </div>
  );
}
